import { Button, Row } from "@narmi/design_system";
import { useLocalization } from "@fluent/react";
import { Dialog } from "cerulean";
import { entities } from "byzantine";

type DeleteTemplateDialogProps = {
  templateId: API.SwiftWireTemplateId;
  templateName: string;
  isOpen: boolean;
  onDismiss: () => void;
};

const DeleteTemplateDialog = ({
  templateId,
  templateName,
  isOpen,
  onDismiss,
}: DeleteTemplateDialogProps) => {
  const { l10n } = useLocalization();
  const { deleteTemplate, loading } =
    entities.swiftwireTemplates.useDeleteTemplateRequest();

  return (
    <Dialog
      isOpen={isOpen}
      onUserDismiss={onDismiss}
      title={l10n.getString("dialog-confirm-delete-template", {
        templateName,
      })}
      width={"385px"}
      footer={
        <Row alignItems="center" justifyContent="end">
          <Row.Item shrink>
            <Button
              onClick={onDismiss}
              kind="negative"
              label={l10n.getString("button-cancel")}
              disabled={loading}
            />
          </Row.Item>
          <Row.Item shrink>
            <Button
              onClick={() => deleteTemplate(templateId)}
              kind="primary"
              label={l10n.getString("button-confirm-delete-template")}
              isLoading={loading}
              disabled={loading}
            />
          </Row.Item>
        </Row>
      }
    >
      <div style={{ overflowWrap: "anywhere" }}>
        {l10n.getString("international-wire-templates-delete-dialog")}
      </div>
    </Dialog>
  );
};

export default DeleteTemplateDialog;
